import { Select } from '@99designs/common/components/Select';
import { handlePromise } from 'common/utils/Bugsnag';
import CreateContext from 'projects/components/CreateContext';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    language: string;
}

interface Props<T> {
    form: ObservableForm<T>;
}

const LanguageField: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
}) => {
    return (
        <CreateContext.Consumer>
            {({ site }) =>
                site && site.acceptedLocales.length ? (
                    <Field
                        form={form}
                        name="language"
                        title={__('Choose your preferred language')}
                        tooltip={__(
                            'We recommend writing your brief in English in order to appeal to the majority of our global design community.'
                        )}
                        render={() => (
                            <Select
                                variations={['max']}
                                name="language"
                                onChange={({ value }) => {
                                    handlePromise(form.set('language', value), 'DetailsPage');
                                }}
                                options={site.acceptedLocales.map(locale => ({
                                    label: locale.title,
                                    value: locale.tag.substr(0, 2),
                                }))}
                                value={form.get('language')}
                            />
                        )}
                    />
                ) : null
            }
        </CreateContext.Consumer>
    );
};

export default LanguageField;
